var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root"},[_c('div',{class:{ primary: true, blur: true, active: _vm.active, curvy: _vm.curvy }},[_vm._t("primary")],2),(_vm.active)?_c('div',{staticClass:"secondary"},[_vm._t("secondary")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }